const fn = ({ Vue, http, guid, i18n }) => {
  Vue.prototype.firstToUpper = str => str !== null && typeof str === 'string' && str.length ? str.charAt(0).toUpperCase() + str.substring(1) : null
  Vue.prototype.stringify = Vue.prototype.$stringify = JSON.stringify
  Vue.prototype.toYmd = timestamp => {
    if (String(timestamp).match(/(....)-(..)-(..)/)) {
      return timestamp
    }
    if (timestamp !== null && timestamp !== '') {
      let date = new Date(parseInt(timestamp))
      let month = date.getMonth() <= 8 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
      let day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()
      return `${date.getFullYear()}-${month}-${day}`
    }
    return timestamp
  }
  Vue.prototype.guid = guid
  Vue.prototype.$http = http
  Vue.prototype.translate = str => {
    const find = `general.${str}`
    const found = i18n.t(find)
    return found && (find !== found) ? found : str
  }
  Vue.prototype.isTruthy = val => {
    const truthyVals = [
      1, '1', 'y', 'Y', 'true', true, 'yes', 'Yes', 'YES'
    ]
    return truthyVals.includes(val)
  }
}

export default fn



// WEBPACK FOOTER //
// ./src/vue-prototype.js